import React from 'react';
import {Container} from 'react-bootstrap';
import {injectIntl} from "gatsby-plugin-intl";
import CasesData from "../../content/home/cases.json"
import CalloutBlock from "../misc/callout-block"

class Cases extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            content: CasesData[props.intl.locale].cases[0]
        }
    }

    componentDidMount() {
        let min= 0, max = CasesData[this.props.intl.locale].cases.length - 1, random = Math.floor(Math.random() * (+max - +min)) + +min;
        this.setState({
            content: CasesData[this.props.intl.locale].cases[random]
        })
    }

    render() {
        return (
            <div className={`home-cases`}>
                <Container>
                    <CalloutBlock theme={`primary`} content={this.state.content} />
                </Container>
            </div>
        )
    }
}

export default injectIntl(Cases)
